import React from 'react';
import PropTypes from 'prop-types';

export const BodyCellPercentage = ({ cell, cellProps }) => {
    const percentage = cell?.value || '0%';

    return (
        <td
            {...cellProps}
            className="stats-table__cell stats-table__cell--percentage"
        >
            <span className="career-and-season-stats__position-cell-label">
                {percentage}
            </span>
        </td>
    );
};

BodyCellPercentage.propTypes = {
    cell: PropTypes.object,
    cellProps: PropTypes.object
};
